import { deleteCookie, getCookie, setCookie } from './cookies';

export const PREVIEW_IDENTITY_EVENT = 'preview-identity-changed';
export const PREVIEW_IDENTITY_NAME_COOKIE = 'creator_preview_identity_name';
export const PREVIEW_IDENTITY_EMAIL_COOKIE = 'creator_preview_identity_email';
const PREVIEW_IDENTITY_COOKIE_DAYS = 30;

export type TPreviewIdentity = {
  name: string;
  email: string;
};

export type TPreviewIdentityInput = Partial<TPreviewIdentity>;

const normalizeValue = (value?: string | null): string => value?.trim() ?? '';

export function readPreviewIdentity(): TPreviewIdentity {
  return {
    name: normalizeValue(getCookie(PREVIEW_IDENTITY_NAME_COOKIE)),
    email: normalizeValue(getCookie(PREVIEW_IDENTITY_EMAIL_COOKIE)),
  };
}

export function resolvePreviewIdentityLabel(identity?: TPreviewIdentity | null): string {
  return identity?.name.trim() || identity?.email.trim() || '';
}

export function hasPreviewIdentity(identity?: TPreviewIdentity | null): boolean {
  return identity?.name.trim() !== '' && identity?.email.trim() !== '';
}

export function hasStoredPreviewIdentity(identity?: TPreviewIdentity | null): boolean {
  return identity?.name.trim() !== '' || identity?.email.trim() !== '';
}

function dispatchPreviewIdentityChange(identity: TPreviewIdentity) {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent<TPreviewIdentity>(PREVIEW_IDENTITY_EVENT, { detail: identity }));
}

export function persistPreviewIdentity(identity: TPreviewIdentityInput): TPreviewIdentity {
  const nextIdentity: TPreviewIdentity = {
    name: normalizeValue(identity.name),
    email: normalizeValue(identity.email),
  };

  if (nextIdentity.name) {
    setCookie(PREVIEW_IDENTITY_NAME_COOKIE, nextIdentity.name, PREVIEW_IDENTITY_COOKIE_DAYS);
  } else {
    deleteCookie(PREVIEW_IDENTITY_NAME_COOKIE);
  }

  if (nextIdentity.email) {
    setCookie(PREVIEW_IDENTITY_EMAIL_COOKIE, nextIdentity.email, PREVIEW_IDENTITY_COOKIE_DAYS);
  } else {
    deleteCookie(PREVIEW_IDENTITY_EMAIL_COOKIE);
  }

  dispatchPreviewIdentityChange(nextIdentity);
  return nextIdentity;
}

export function clearPreviewIdentity(): TPreviewIdentity {
  deleteCookie(PREVIEW_IDENTITY_NAME_COOKIE);
  deleteCookie(PREVIEW_IDENTITY_EMAIL_COOKIE);

  const clearedIdentity: TPreviewIdentity = { name: '', email: '' };
  dispatchPreviewIdentityChange(clearedIdentity);
  return clearedIdentity;
}
